export const STORAGE_MODE = {
  RAM: 'RAM',
  IDB: 'IDB',
  FILE: 'FILE',
  DYNAMODB: 'DYNAMODB',
  S3: 'S3',
};